import { Box, Button, Dialog, SxProps, Typography } from '@mui/material';

import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import ImageWrapper from '../../elements/ImageWrapper';
import PrimaryButton from '../../elements/PrimaryButton';
import { ReactNode } from 'react';

interface IProps {
  iconName: string;
  buttontext: string;
  textcolor?: string;
  background?: string;
  open: boolean;
  handleClose?: () => void;
  ctaHandler: () => void;
  childrenText?: ReactNode;
  customSx?: SxProps
}
const styles: IStyles = {
  root: {},
  iconBox: {
    height: { xs: pxToRem(113), md: pxTovW(231) },
    display: 'flex',
    width: { xs: pxToRem(113), md: pxTovW(231) },
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    transform: 'translateY(-50%)',
  },
};

export const ClickerPoupSingleButton = (props: IProps) => {
  const {
    open,
    iconName,
    buttontext,
    textcolor,
    background,
    handleClose,
    ctaHandler,
    childrenText,
    customSx
  } = props;
  return (
    <Dialog open={open} onClose={handleClose && handleClose}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            height: 'auto',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'white',
            width: { xs: pxToRem(295), md: pxTovW(980), lg: pxTovW(680) },
            borderRadius: { xs: pxTovW(20), md: pxTovW(20) },
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              top: '0px',
              left: '0%',
              height: pxTovW(8),
              width: '100%',
            }}
          >
            <IconBox iconName={iconName} customSx={customSx} />
          </Box>
          <Box sx={{
            marginTop: { xs: pxToRem(50), md: pxTovW(100) },
            marginBottom: { xs: pxTovW(30), md: pxTovW(45) }
          }}>
            {childrenText ? (
              childrenText
            ) : (
              <Box sx={{
                textAlign: 'center',
                height: '100%',
                width: { xs: '90%', md: '85%' },
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: pxTovW(10), md: pxTovW(20) },
                marginX: 'auto'
              }}>
                <Typography variant='g2' fontWeight={'regular'}>
                  This is a clicker-based assessment that can only be initiated by the teacher within a classroom setting.
                </Typography>
                <Typography variant='g2' fontWeight={'regular'}>
                  Once the Assessment Ended You can come and see the results
                </Typography>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-around',
              // marginBottom: '29px',
              marginBottom: { xs: pxToRem(34), md: pxTovW(34) },
              '& button': {
                maxWidth: '80%',
              },
            }}
          >
            {!textcolor ? (
              <Button
                variant="outlined"
                sx={{
                  height: { xs: pxToRem(48), md: pxTovW(78) },
                  width: { xs: pxToRem(120), md: pxTovW(249) },
                  maxWidth: '10%',
                  backgroundColor: '#0AA34F',
                  border: '1px solid rgba(10, 242, 116, 1)',
                  '&:hover': {
                    backgroundColor: '#0AA34F',
                    border: '1px solid rgba(10, 242, 116, 1)',
                  },
                }}
                onClick={ctaHandler}
              >
                <Typography variant="h3" color={'common.white'} fontWeight={'Bold'}>{buttontext}</Typography>
              </Button>
            ) : (
              <PrimaryButton onClick={ctaHandler}>{buttontext}</PrimaryButton>
            )}
          </Box>
        </Box>
      </Box>
    </Dialog >
  );
};
interface IConProps {
  iconName: string;
  customSx?: SxProps;
}
const IconBox = (props: IConProps) => {
  const { iconName, customSx } = props;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={styles.iconBox}>
        <ImageWrapper
          name={iconName}
          parentFolder="icons"
          type="png"
          styles={customSx
            ? customSx : {
              height: { xs: pxToRem(64), md: pxTovW(118) },
              width: { xs: pxToRem(44), md: pxTovW(74) },
            }}
        />
      </Box>
    </Box>
  );
};
